export interface ICountry {
    children: string;
    code: string;
    icon: string;
    id: number;
    mobileWeb: boolean;
    permitted: boolean;
    showDeviceIcon: boolean;
    text: string;
    tooltipText: string;
}

export enum ESortingType {
    NAME,
    DATA,
}
